import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=6a978b7d"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"
import style0 from "./ContactList.vue?vue&type=style&index=0&id=6a978b7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports